import { styled } from '@mui/material/styles';
import MuiTypography from '@mui/material/Typography';
import MuiBox from '@mui/material/Box';
import {
  proAccountThemeCoreUI,
  type IStylesOverrides,
} from '@orcha/micro-library-core-ui';
import type { StyledComponent } from '@emotion/styled';

type StyledBoxProps = {
  styleOverrides?: IStylesOverrides;
};

export const StyledBox: StyledComponent<any> = styled(MuiBox, {
  shouldForwardProp: (prop) => prop !== 'styleOverrides',
})<StyledBoxProps>(({ theme, styleOverrides }) => ({
  backgroundColor:
    styleOverrides?.backgroundColour ?? theme.palette.common.white,
  paddingTop: styleOverrides?.paddingTop ?? theme.spacing(1),
  paddingBottom: styleOverrides?.paddingBottom ?? theme.spacing(1),
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  [theme.breakpoints.up('sm')]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  [theme.breakpoints.up('md')]: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  borderRadius: '8px',
}));

export const HeadingTypography: StyledComponent<any> = styled(MuiTypography)(
  ({ theme }) => ({
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(1),
    color: '#000',
    fontSize: '16px',
    fontFamily: proAccountThemeCoreUI.typography.fontFamily,
  })
);

export const DescriptionTypography: StyledComponent<any> = styled(
  MuiTypography
)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  color: '#000',
  maxWidth: '900px',
  paddingTop: theme.spacing(1),
  fontSize: '14px',
  fontFamily: proAccountThemeCoreUI.typography.fontFamily,
}));
